import angular from 'angular';

import uiRouter from 'angular-ui-router';
import ListComponent from './list.component';
import routing from './list.routes';

export default angular
  .module('verifyApp.report-list', [uiRouter])
  .config(routing)
  .component('reportList', ListComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/reports/list/index.js